














import { Vue, Component, Watch, Mixins } from "vue-property-decorator";
import { FeathersVuexFindAll } from "@/utils";
import UserRoleMixin from "../../../mixins/UserRoleMixin.vue";
import { Sync } from "vuex-pathify";
import { nil } from "@/common";
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
@Component({
  components: {}
})
export default class PackageSelection extends Mixins(UserRoleMixin, GlobalAlertMixin) {
  private packages = [
    {
      html: `<b> 5 Plush Blowouts</b> for <b>$255</b> ($300 value)`,
      description: "5 Plush Blowouts for $255",
      tierName: "Plush",
      serviceName: "Blowout",
      quantity: 5,
      discount: 45,
      discountFlat: true,
      type: "Bundle",
      code: "P4HKNZ7JFB64"
    },
    {
      html: `<b>10 Plush blowouts</b> for <b>$510</b> ($600 value)`,
      description: "10 Plush Blowouts for $510",
      tierName: "Plush",
      serviceName: "Blowout",
      quantity: 10,
      discount: 90,
      discountFlat: true,
      type: "Bundle",
      code: "323JDZQ5M27K"
    },
    {
      html: `<b>3 Plush makeup with lash</b> applications and get <b>1 free blowout</b>`,
      description:
        "1 Free Blowout With a Purchase of 3 Plush Makeup With Lashes",
      tierName: "Plush",
      serviceName: "Makeup With Lashes",
      quantity: 3,
      type: "freeAddOn",
      addon: {
        serviceName: "Blowout"
      },
      code: "MBGQ7T44L849"
    },
    {
      html: `<b>Bridal party</b> of 10+ receive <b>10% off full services</b>`,
      type: "ConditionalDiscount",
      description: "Bridal party of 10+ receive 10% off full services",
      condition: "BRIDAL_PARTY_10PERCENT_OFF",
      discount: 0.1,
      discountFlat: false,
      code: "KAL8XVGJJJML"
    }
  ];
  @Sync("booking/tier") public tier!: any;
  @Sync("booking/category") public category!: any;
  @Sync("booking/services") public services!: any[];
  @Sync("booking/durations") public durations!: number[];
  @Sync("booking/guests") public guests!: number[];
  @Sync("booking/discount") public discount!: number;
  @Sync("booking/discountIsFlat") public discountIsFlat!: boolean;
  @Sync("booking/discountDescription") public discountDescription!: string;
  @Sync("booking/discountForOrder") public discountForOrder!: boolean;
  @Sync("booking/editingSerivce") public editingSerivce!: number;
  @Sync("booking/discountConditional") public discountConditional!: string;

  public checkedPackage = false;
  public foundPackage = null;
  public redirectTimer = 10;
  public redirectInterval = null;
  public get body() {
    if (!this.checkedPackage) {
      return "Please wait...";
    }
    return this.foundPackage
      ? `Applying ${this.foundPackage.description}`
      : `Sorry, we couldn't locate this package.`;
  }
  public mounted() {
    const { code } = this.$route.query;
    let found = false;
    if (code) {
      const [match] = this.packages.filter(x => x.code === code);
      if (match) {
        this.foundPackage = match;
        this.addPackageToCart(match);
      }
    }
    this.checkedPackage = true;
    if (nil(this.foundPackage)) {
    }
    this.redirectInterval = setInterval(() => {
      this.redirectTimer--;
      if (this.redirectTimer === 0) {
        this.redirect();
      }
    }, 1000);
  }

  public async addPackageToCart(pkg) {
    switch (pkg.type) {
      case "Bundle":
        this.bundleBooking(pkg);
        break;
      case "freeAddOn":
        this.freeAddOnBooking(pkg);
        break;
      case "ConditionalDiscount":
        this.conditionalDiscount(pkg);
        break;
    }
  }

  public async bundleBooking({
    tierName,
    serviceName,
    quantity,
    discount,
    description
  }) {
    const { Tier, Category, Purchasable } = this.$FeathersVuex;
    const t = await Tier.find({ query: { name: tierName } });
    const c = await Category.find({ query: { name: "Personal" } });
    const services = await Purchasable.find({
      query: {
        name: serviceName,
        category: c.data[0]._id,
        tier: t.data[0]._id
      }
    });
    if (services.total !== 1) {
      this.showAlert("Sorry, there was an issue finding this package");
    } else {
      const [service] = services.data;
      this.tier = t.data[0];
      this.category = c.data[0];
      const tempServices = [];
      for (let i = 0; i < quantity; i++) {
        tempServices.push(service);
        this.guests[i] = 1;
        this.durations[i] = 1;
      }
      this.editingSerivce = 0;
      this.discountIsFlat = true;
      this.discount = discount;
      this.discountDescription = description;
      this.discountForOrder = true;
      this.services = tempServices;
      this.$router.replace("/package");
    }
  }

  public async freeAddOnBooking({
    tierName,
    serviceName,
    quantity,
    description,
    addon
  }) {
    const { Tier, Category, Purchasable } = this.$FeathersVuex;
    const t = await Tier.find({ query: { name: tierName } });
    const c = await Category.find({ query: { name: "Personal" } });
    const services = await Purchasable.find({
      query: {
        name: serviceName,
        category: c.data[0]._id,
        tier: t.data[0]._id
      }
    });
    const addonServices = await Purchasable.find({
      query: {
        name: addon.serviceName,
        category: c.data[0]._id,
        tier: t.data[0]._id
      }
    });
    if (services.total !== 1 || addonServices.total !== 1) {
      this.showAlert("Sorry, there was an issue finding this package");
    } else {
      const [service] = services.data;
      const [addonService] = addonServices.data;
      const tempServices = [];
      for (let i = 0; i < quantity; i++) {
        tempServices.push(service);
        this.guests[i] = 1;
        this.durations[i] = 1;
      }
      tempServices.push(addonService);
      this.editingSerivce = 0;
      this.discountIsFlat = true;
      this.discount = addonService.price;
      this.discountDescription = description;
      this.discountForOrder = false;
      this.services = tempServices;
      this.$router.replace("/package");
    }
  }

  public async conditionalDiscount({ condition, discount, description }) {
    this.editingSerivce = 0;
    this.discountIsFlat = false;
    this.discount = discount;
    this.discountDescription = description;
    this.discountConditional = condition;
    this.discountForOrder = true;
    this.$router.replace("/");
  }
  public redirect() {
    clearInterval(this.redirectInterval);
    if (this.foundPackage) {
      return;
    }
    document.location.href = "https://soplushbeauty.com";
  }
}
